import cx from "clsx";
import { PolicyDetailInfo } from "kreate-common/modules/business-types";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import Link from "next/link";
import React from "react";

import styles from "./index.module.scss";

import useFormattedPolicy from "@/modules/common-hooks/useFormattedPolicy";
import {
  formatInteger$Standard,
  formatInteger$Compact,
} from "@/modules/common-utils/format";
import { ImageViewer } from "@/modules/kreate-components/components/ImageViewer";
import PolicyTitleViewer from "@/modules/kreate-components/components/PolicyTitleViewer";
import UserDisplayNameViewerV2 from "@/modules/kreate-components/components/UserDisplayNameViewerV2";
import { getLinkToPagePolicy } from "@/modules/navigation/utils/getLinkTo";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  collection: PolicyDetailInfo;
};

export default function FeaturedCollectionViewer({
  className,
  style,
  collection,
}: Props) {
  const { avatar } = useFormattedPolicy(collection, { returnBanner: false });
  return (
    <div className={cx(styles.container, className)} style={style}>
      <Flex.Row gap="24px">
        <Flex.Cell flex="0 0 auto" className={styles.avatarContainer}>
          <Link
            href={collection ? getLinkToPagePolicy(collection) : "#disabled"}
          >
            <ImageViewer value={avatar} sizing="fill" sizes="96px" />
          </Link>
        </Flex.Cell>
        <Flex.Col
          flex="0 1 auto"
          gap="8px"
          minWidth="0"
          justifyContent="center"
        >
          <Flex.Cell minWidth="0" className={styles.collectionTitle}>
            <PolicyTitleViewer policyDetailInfo={collection} unstyled />
          </Flex.Cell>
          <Flex.Row gap="4px" alignItems="center" minWidth="0">
            <span className={styles.textBy}>{"By: "}</span>
            <UserDisplayNameViewerV2
              className={styles.displayNameViewer}
              user={collection?.populated?.userProfile}
              hideIcons
              unstyled
            />
          </Flex.Row>
          <Flex.Cell
            className={styles.textNumToken}
            title={formatInteger$Standard(collection.quantity)}
          >
            {`${formatInteger$Compact(collection.quantity)} assets`}
          </Flex.Cell>
        </Flex.Col>
      </Flex.Row>
    </div>
  );
}
